import type { ReactNode } from 'react';

export const symbol_passkey: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-160q-24.75 0-42.37-17.63Q120-195.25 120-220v-34q0-38 19-65t49-41q67-30 128.5-45T440-420q21 0 42 1.5t42 5.5q8 2 12 7.19t4 12.81q0 50 23 93.5t64 71.5q6.07 3.97 9.53 9.91Q640-212.14 640-205v15q0 12.75-8.62 21.37Q622.75-160 610-160H180Zm260-340q-63 0-106.5-43.5T290-650q0-63 43.5-106.5T440-800q63 0 106.5 43.5T590-650q0 63-43.5 106.5T440-500Zm328.5 115.5Q780-396 780-413t-11.5-28.5Q757-453 740-453t-28.5 11.5Q700-430 700-413t11.5 28.5Q723-373 740-373t28.5-11.5ZM749-24l-44.76-44.76Q702-71 700-79v-179.86Q656-272 628-308.5T600-393q0-58 41-99t99-41q58 0 99 41t41 99q0 45-25.5 80T790-263l39 39q5 4.64 5 10.82 0 6.18-5 11.18l-38 38q-5 4.64-5 10.82 0 6.18 5 11.18l38 38q5 4.64 5 10.82Q834-87 829-82l-58 58q-4.64 5-10.82 5Q754-19 749-24Z"
		/>
	</svg>
);
